import moment from 'moment'

/**
 * 売上明細の検索・入金一覧・会計の出力で選べる期間の最大日数（開始日と終了日を含む）。
 * backend の SalesPeriodMaxDaysRule::MAX_DAYS と揃える
 */
const SALES_MAX_PERIOD_DAYS = 180

/**
 * 期間（YYYY-MM-DD）が最大日数を超えるか。日付の選択中は片方だけのことがあるため、未指定なら判定しない。
 * backend は片方だけの指定を拒否するため、送る前に両方そろっていることは呼び出し側で確かめる
 */
export const exceedsSalesMaxPeriod = (beginDate: string | undefined, endDate: string | undefined): boolean => {
  if (!beginDate || !endDate) {
    return false
  }
  return calendarDaysBetween(beginDate, endDate) + 1 > SALES_MAX_PERIOD_DAYS
}

/**
 * 暦日の差。ブラウザのタイムゾーンで夏時間をまたぐと 1 日が 23 時間になり、dayjs の diff が 1 日少なく切り捨てるため、UTC の日付で数える
 */
const calendarDaysBetween = (beginDate: string, endDate: string): number => {
  const toUtcDays = (date: string) => {
    const [year, month, day] = date.split('-').map(Number)
    return Date.UTC(year, month - 1, day) / (24 * 60 * 60 * 1000)
  }
  return toUtcDays(endDate) - toUtcDays(beginDate)
}

/**
 * DateRangeField の isOutsideRange 用。終了日を選ぶときに、開始日から最大日数を超える日を選べないようにする
 */
export const isOutsideSalesMaxPeriod = (
  day: moment.Moment,
  focusedInput: 'startDate' | 'endDate' | null,
  beginDate: string | undefined,
): boolean => {
  if (focusedInput !== 'endDate') {
    return false
  }
  return exceedsSalesMaxPeriod(beginDate, day.format('YYYY-MM-DD'))
}
